<div class="app-container">
  <page-header [title]="'dashboard'" [icon]="'fa-chart-pie'" [fullWidthPageTitle]="true"></page-header>
  <div *ngIf="trialService.shouldDisplayBottomInfoBanner" class="trial-bottom-info-banner">
    <div class="trial-bottom-info-banner-text">
      <div class="trial-bottom-info-banner-text-top">
        <strong>
          {{ 'trial.bottom-info-banner-row-a' | translate }} {{ trialService.trialDaysTillEnd }}
          {{
            trialService.trialDaysTillEnd === 1
              ? ('trial.bottom-info-banner-row-a-day' | translate)
              : trialService.trialDaysTillEnd >= 2 && trialService.trialDaysTillEnd <= 4
                ? ('trial.bottom-info-banner-row-a-days2' | translate)
                : ('trial.bottom-info-banner-row-a-days5' | translate)
          }}
        </strong>
      </div>
      <div class="trial-bottom-info-banner-text-bottom">
        {{ 'trial.bottom-info-banner-row-b' | translate }}
        <a href="mailto:podpora@evidentist.cz">{{ 'trial.bottom-info-banner-row-contact' | translate }}</a>
      </div>
    </div>
    <div class="trial-bottom-info-banner-btn">
      <btn
        [classes]="['btn', 'btn-white']"
        [label]="'trial.bottom-info-banner-button' | translate"
        (onEvent)="trialService.getFullVersion()"
      ></btn>
    </div>
  </div>
  <section class="content">
    <div class="row">
      <div class="col-12 col-lg-6 hp-col">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">
              <i class="fa fa-bar-chart-o"></i>
              {{ 'home.out-of-stock' | translate }}
            </h3>
          </div>

          <loading-spinner [isLoading]="loading" [classesString]="'pt-88'"></loading-spinner>

          <div *ngIf="!loading && productsUnderMinimum?.length < 1">
            {{ 'home.no-out-of-stock' | translate }}
          </div>

          <table class="table" *ngIf="!loading && productsUnderMinimum?.length">
            <tbody [photoGalleryGroup]="{ index: 1 }">
              <tr *ngFor="let product of productsUnderMinimum">
                <td>
                  <div
                    [photoGallery]="getThumbUrl(product.mainImage, 'w2048wp')"
                    [photoGalleryCaption]="
                      product.name +
                      '<br>' +
                      (product.code ? ('home.code' | translate) + product.code : '') +
                      '<br>' +
                      (product.ean ? ('home.ean' | translate) + product.ean : '')
                    "
                  >
                    <div class="images-item">
                      <img class="images-item-image" [src]="getThumbUrl(product.mainImage)" [alt]="product.name" />
                    </div>
                  </div>
                </td>
                <td>
                  <div>
                    <span>
                      <a [routerLink]="product.id ? ['/product', product.id] : null">{{ product.name }}</a>
                    </span>
                  </div>
                  <div>
                    {{
                      'home.codes'
                        | translate
                          : { productCode: product.code, productCode2: product.code2, productCode3: product.code3 }
                    }}
                  </div>
                </td>
                <td style="white-space: nowrap">
                  <div class="text-nowrap">{{ product.quantityStock + ('home.piece' | translate) }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-12 col-lg-6 hp-col">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">
              <i class="fa fa-bar-chart-o"></i>
              {{ 'home.expiration' | translate }}
            </h3>
          </div>

          <loading-spinner [isLoading]="loading" [classesString]="'pt-88'"></loading-spinner>

          <div *ngIf="!loading && productsBeforeExpiration?.length < 1">
            {{ 'home.no-products-before-expiration' | translate }}
          </div>

          <table class="table" *ngIf="!loading && productsBeforeExpiration?.length">
            <tbody [photoGalleryGroup]="{ index: 1 }">
              <tr *ngFor="let product of productsBeforeExpiration">
                <td>
                  <div
                    [photoGallery]="getThumbUrl(product.mainImage, 'w2048wp')"
                    [photoGalleryCaption]="
                      product.name +
                      '<br>' +
                      (product.code ? ('home.code' | translate) + product.code : '') +
                      '<br>' +
                      (product.ean ? ('home.ean' | translate) + product.ean : '')
                    "
                  >
                    <div class="images-item">
                      <img class="images-item-image" [src]="getThumbUrl(product.mainImage)" [alt]="product.name" />
                    </div>
                  </div>
                </td>
                <td>
                  <div>
                    <span>
                      <a [routerLink]="product.id ? ['/product', product.id] : null">{{ product.name }}</a>
                    </span>
                  </div>
                  <div>
                    {{
                      'home.codes'
                        | translate
                          : { productCode: product.code, productCode2: product.code2, productCode3: product.code3 }
                    }}
                  </div>
                </td>
                <td>
                  <div class="text-nowrap">{{ product.quantityStock + ('home.piece' | translate) }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-12 col-lg-6 hp-col" *ngIf="canViewPurchaseOrderItems">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">
              <i class="fa fa-bar-chart-o"></i>
              {{ 'home.purchase-order-items' | translate }}
            </h3>
          </div>

          <loading-spinner [isLoading]="loading" [classesString]="'pt-88'"></loading-spinner>
          <div *ngIf="!loading && !purchaseOrderItems?.length">
            {{ 'home.moves.no-available' | translate }}
          </div>

          <table class="table" *ngIf="!loading && purchaseOrderItems?.length">
            <tbody [photoGalleryGroup]="{ index: 1 }">
              <tr *ngFor="let poItem of purchaseOrderItems">
                <td>
                  <div
                    [photoGallery]="getThumbUrl(poItem.product.mainImage, 'w2048wp')"
                    [photoGalleryCaption]="
                      poItem.product.name +
                      '<br>' +
                      (poItem.product.code ? ('home.code' | translate) + poItem.product.code : '') +
                      '<br>' +
                      (poItem.product.ean ? ('home.ean' | translate) + poItem.product.ean : '')
                    "
                  >
                    <div class="images-item">
                      <img
                        class="images-item-image"
                        [src]="getThumbUrl(poItem.product.mainImage)"
                        [alt]="poItem.product.name"
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div>
                    <span>
                      <a [routerLink]="poItem.product.id ? ['/product', poItem.product.id] : null">{{
                        poItem.product.name
                      }}</a>
                    </span>
                  </div>
                  <div>
                    <span *ngIf="poItem.product.code?.length"
                      >{{ 'm.code' | translate }}: {{ poItem.product.code }},
                    </span>
                    <span *ngIf="poItem.product.code2?.length">DL: {{ poItem.product.code2 }}, </span>
                    <span *ngIf="poItem.product.code3?.length"
                      >{{ 'producer.code' | translate }}: {{ poItem.product.code3 }}</span
                    >
                    <!--                    {{'home.codes' | translate: {productCode: poItem.product.code, productCode2: poItem.product.code2, productCode3: poItem.product.code3} }}-->
                  </div>
                </td>
                <td>
                  <div class="text-nowrap">{{ poItem.quantity + ('home.piece' | translate) }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-12 col-lg-6 hp-col">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">
              <i class="fa fa-bar-chart-o"></i>
              {{ 'home.moves.last' | translate }}
            </h3>
          </div>

          <loading-spinner [isLoading]="loading" [classesString]="'pt-88'"></loading-spinner>
          <div *ngIf="!loading && !lastMoves?.length">
            {{ 'home.moves.no-available' | translate }}
          </div>

          <table class="table" *ngIf="!loading && lastMoves?.length">
            <tbody>
              <tr *ngFor="let move of lastMoves">
                <td>
                  <i
                    [ngClass]="
                      move.type.id === 'in'
                        ? 'in-badge fas fa-plus-square'
                        : move.type.id === 'out'
                          ? 'out-badge fas fa-minus-square'
                          : move.type.id === 'transfer'
                            ? 'transfer-badge fas fa-exchange-alt'
                            : ''
                    "
                  ></i>
                </td>
                <td>
                  <div>
                    <span>
                      <a [routerLink]="move.id ? ['/product-move-pack', move.id] : null">{{ move.number }}</a>
                    </span>
                  </div>
                  <div>
                    {{
                      move.createdBy?.firstName + move.createdBy?.lastName
                        ? move.createdBy.firstName + ' ' + move.createdBy.lastName
                        : ''
                    }}
                  </div>
                </td>
                <td>
                  <div>
                    {{
                      getQuantityItemsSum(move) +
                        ' ' +
                        ('bill.quantity' | translate) +
                        ' / ' +
                        (move.moves | listLength) +
                        ' ' +
                        ('bill.amount' | translate)
                    }}
                  </div>
                </td>
                <td>
                  <div>{{ move.dateCreated | fmtDate: 'dd.MM.yyyy' }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</div>
